module.exports = __webpack_public_path__ + "img/face-recognition.5892278a.svg";